import { store } from "@betacrew/jars-flux";
import { componentKey, setLoadingState, setPayrollStatusList, setSelectedPayrollStatus, setPayrollStateList, setSelectedPayrollState, setPayrollFormList, setSelectedPayrollForm, setPayrollTaxYearList, setPayrollPayerList, setSelectedPayrollPayer, setStatePayrollFormsGrid, setSelectedStatePayrollFormsGrid, setPaginationState, setPayrollApproveFormsModal, setPayrollRejectFormsModal, setReloadGridData, setFormApprovalSuccess, setUrlStatusParam, setUrlFormIdParam, setUrlPayerIdParam, setSelectedPayrollTaxYear } from "./StatePayrollReviewApproveFormsSlice";
import { all, put, takeLatest } from "redux-saga/effects";
import RightsManagementDataService from "../../../../../services/RightsManagementDataService";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import General from "../../../../../libs/utility/General";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { setPayrollRejectFormRemark } from "../statepayrollreviewapproveforms/StatePayrollReviewApproveFormsSlice"
import { REVIEW_AND_APPROVE_FORMS_LOADING_STATES, REVIEW_APPROVE_FORMS_LOADING_STATES } from "../constants";

export const { getStatePayrollReviewAndApproveStatuses, getStatePayrollReviewAndApproveStates, getStatePayrollReviewAndApproveForms, getStatePayrollReviewAndApprovePayers, getreviewAndApproveGridData, statePayrollrejectForm, statePayrollapproveForm, viewStatePayrollReviewAndApproveFormPDF } = {
    getStatePayrollReviewAndApproveStatuses: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/GET_STATUSES",
            payload
        }
    },

    getStatePayrollReviewAndApproveStates: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/GET_STATES",
            payload
        }
    },

    getStatePayrollReviewAndApproveForms: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/GET_FORMS",
            payload
        }
    },

    getStatePayrollReviewAndApprovePayers: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/GET_PAYERS",
            payload
        }
    },

    getreviewAndApproveGridData: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/GET_PAYROLL_GRID_DATA",
            payload
        }
    },

    statePayrollrejectForm: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/PAYROLL_REJECT_FORM",
            payload
        }
    },

    statePayrollapproveForm: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/PAYROLL_APPROVE_FORM",
            payload
        }
    },

    viewStatePayrollReviewAndApproveFormPDF: (payload) => {
        return {
            type: "REVIEW_APPROVE_STATE_PAYROLL_FORMS/VIEW_PDF",
            payload
        }
    },
}

function* getStatePayrollReviewAndApproveStatusesAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_LOADING, message: "Fetching Data" }));

        const { status = null } = action?.payload;
        const response = yield RightsManagementDataService.reviewAndApproveStatuses();
        const { Message, Status, Data } = response?.data || {};

        if (Status === 1 && Data.length > 0) {
            General.addOptionAndValueKeys(Data, "status", "statusId")

            if (status) {
                const tmpStatus = Data.find(r => r.status == status);

                if (tmpStatus) {
                    yield put(setSelectedPayrollStatus(tmpStatus));
                }
                yield put(setUrlStatusParam(null));

                if (status) {
                    const findSelectedStatusRecord = Data.find(item => item?.value == status)
                    if (findSelectedStatusRecord) {
                        yield put(setSelectedPayrollStatus(findSelectedStatusRecord))
                    }
                    yield put(setUrlStatusParam(null));
                }
            }
            yield put(setPayrollStatusList(Data))

        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_READY }))
    }
}

function* getStatePayrollReviewAndApproveStatesAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_LOADING, message: "Fetching Data" }));
        const { urlStateParam, urlTaxYearParam = null } = action.payload;

        const response = yield RightsManagementDataService.getStatePayrollStateNames();
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data?.StateNames && Data?.TaxYears) {
                const stateList = [...Data.StateNames];
                const taxYearsList = [...Data.TaxYears];

                General.addOptionAndValueKeys(stateList, "StateName", "StateName");
                General.addOptionAndValueKeys(taxYearsList, "TaxYear", "TaxYear");

                yield all([
                    put(setPayrollStateList(stateList)),
                    put(setPayrollTaxYearList(taxYearsList))
                ]);

                if (urlStateParam) {
                    const findSelectedStateRecord = stateList.find(state => state?.value === urlStateParam)
                    if (findSelectedStateRecord) {
                        yield put(setSelectedPayrollState(findSelectedStateRecord))
                    }
                }

                if (urlTaxYearParam) {
                    const findSelectedTaxYearRecord = taxYearsList.find(taxYear => taxYear?.value === urlTaxYearParam)
                    if (findSelectedTaxYearRecord) {
                        yield put(setSelectedPayrollTaxYear(findSelectedTaxYearRecord))
                    }
                }

            } else {
                yield put(addNotifications({ heading: "Error", message: "Please try again" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_READY }))
    }
}

function* getStatePayrollReviewAndApproveFormsAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING, message: "Fetching Forms List" }));
        const { urlFormIdParam = null } = action.payload;
        const params = action.payload.stateNames;
        const response = yield RightsManagementDataService.getStatePayrollFormNames(params)
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "FormName1", "FormId");
                yield put(setPayrollFormList(Data))

                if (urlFormIdParam) {
                    const findSelectedFormRecord = Data.find(item => item?.value == urlFormIdParam)
                    if (findSelectedFormRecord) {
                        yield put(setSelectedPayrollForm(findSelectedFormRecord))
                    }
                    yield put(setUrlFormIdParam(null));
                }

            } else {
                yield put(addNotifications({ heading: "Error", message: "Forms not found" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* getStatePayrollReviewAndApprovePayersAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING, message: "Fetching Payers" }));
        const { urlPayerIdParam = null } = action.payload;
        const { formId } = action.payload;
        const params = { formId }

        const response = yield RightsManagementDataService.reviewAndApprovePayers(params)
        const { Message, Status, Data } = response?.data;

        if (Status === 1) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId");
                yield put(setPayrollPayerList(Data))

                if (urlPayerIdParam) {
                    const findSelectedPayerRecord = Data.find(item => item?.value == urlPayerIdParam)
                    if (findSelectedPayerRecord) {
                        yield put(setSelectedPayrollPayer(findSelectedPayerRecord))
                        yield put(setReloadGridData(true));
                    }
                    yield put(setUrlPayerIdParam(null));
                }

            } else {
                yield put(addNotifications({ heading: "Error", message: "Payers not found" }));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getreviewAndApproveGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING, message: "Fetching Data" }));

        const { paginationState, formId, taxyear, payerId, formstatus } = action?.payload;

        const params = {
            PageSize: paginationState?.PageSize || 10,
            PageNumber: paginationState?.PageNumber || 1,
            formId,
            taxyear,
            payerId,
            formstatus,
            FilterText: "0",
            IdNumber: "0",
            IsDesc: false
        };

        const response = yield RightsManagementDataService.reviewAndApproveGridData(params);

        const { Status, Data } = response?.data || {};

        if (Status === 1 && Data.length > 0) {
            yield put(setStatePayrollFormsGrid(Data));
            yield put(setPaginationState({ ...paginationState, total: Data?.Total || Data.length }))
        } else {
            yield put(setStatePayrollFormsGrid([]));
            yield put(setSelectedStatePayrollFormsGrid([]));
            yield put(setPaginationState({ ...paginationState, total: 0 }))
        }
        yield put(setReloadGridData(false));
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }
}

function* statePayrollrejectFormAsync(action) {

    try {
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_LOADING, message: "Loading" }));

        const { formIds, payerId, formName, payerName, taxyear, remarks, paginationState, formId, formstatus } = action.payload;

        const params = {
            formIds,
            payerId,
            formName,
            payerName,
            taxyear,
            remarks
        };
        const response = yield RightsManagementDataService.reviewApproveRejectForms(params);

        const { Status, Message } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Form(s) Rejected Successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(getreviewAndApproveGridData({ paginationState, formId, taxyear, payerId, formstatus }))
        } else {
            yield put(addNotifications({ heading: "Failed to reject the form", message: Message }));
        }
    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setPayrollRejectFormsModal(false))
        yield put(setPayrollRejectFormRemark(""))
        yield put(setLoadingState({ state: REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_READY }))
    }
}

function* statePayrollapproveFormAsync(action) {

    try {
        yield put(setPayrollApproveFormsModal(false))
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING, message: "Loading" }));

        const { formIds, payerId, formName, payerName, taxyear, paginationState, formId, formstatus } = action.payload;

        const params = {
            formIds,
            payerId,
            formName,
            payerName,
            taxyear
        };
        const response = yield RightsManagementDataService.approveForms(params);
        const { Status, Message } = response?.data;

        if (Status === 1) {
            yield put(getreviewAndApproveGridData({ paginationState, formId, taxyear, payerId, formstatus }))
            yield put(setFormApprovalSuccess(true));
        } else {
            yield put(addNotifications({ heading: "Failed to approve the form", message: Message }));
        }
    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_READY }))
    }

}

function* viewStatePayrollReviewAndApproveFormPDFAsync(action) {
    try {
        const { formId, payerId, formTypeId, payerName } = action.payload
        yield put(setLoadingState({ state: `${REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${formId}` }));

        const data = {
            formId,
            payerId: payerId,
            formTypeId: formTypeId,
            PayerName: payerName,
            isUnMask: false,
            employerId: 0
        }

        const response = yield SubmitFormsDataService.viewStatePayrollPDF(data);

        const { Message, Status, Data } = response?.data;

        if (Status === 1 && Data) {
            General.openBase64FileInNewTab(Data?.Base64, Data?.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LIST_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStatePayrollReviewAndApproveStatuses().type, getStatePayrollReviewAndApproveStatusesAsync),
        takeLatest(getStatePayrollReviewAndApproveStates().type, getStatePayrollReviewAndApproveStatesAsync),
        takeLatest(getStatePayrollReviewAndApproveForms().type, getStatePayrollReviewAndApproveFormsAsync),
        takeLatest(getStatePayrollReviewAndApprovePayers().type, getStatePayrollReviewAndApprovePayersAsync),
        takeLatest(getreviewAndApproveGridData().type, getreviewAndApproveGridDataAsync),
        takeLatest(statePayrollrejectForm().type, statePayrollrejectFormAsync),
        takeLatest(statePayrollapproveForm().type, statePayrollapproveFormAsync),
        takeLatest(viewStatePayrollReviewAndApproveFormPDF().type, viewStatePayrollReviewAndApproveFormPDFAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);

